// One list of every proactive message and who goes first when several are
// ready at the same time (see services/messageQueue). Higher wins within a
// lane. Keep the ordering here so the sequence a member sees is decided in
// one place rather than by whichever component happened to mount first.
export const MESSAGE_PRIORITY = {
  // Inline lane — one card at a time in the page's nudge slot; the next one
  // takes the slot when the member dismisses the current one.
  reorderNudge: 90,
  rewardProgress: 80,
  boxUpgradeOffer: 50,
  creditOffer: 40,
  // Celebration + referral ask — a nice moment, never ahead of box housekeeping.
  referralMilestone: 20,

  // Floating lane — coach marks and bottom prompts, one at a time.
  // First-visit orientation: what the pill is, where plan settings live.
  boxCoachMark: 70,
  planSettingsCoachMark: 60,
  // Reactive prompts right after a member adds something — contextual, so
  // they outrank the housekeeping but expire quickly if the slot is busy.
  // A recipe the just-added product completes outranks a single pairing.
  recipeSuggestion: 57,
  pairingSuggestion: 56,
  crossSell: 55,
  // Housekeeping — nice to have, never before anything about the member's box.
  pwaInstall: 30,
};

// How long a reactive prompt will wait for the slot before it goes stale.
export const REACTIVE_MAX_WAIT_MS = 4000;
